const removeZeros = (num) => {
    let strNum = num.toString();
    strNum = strNum.replace(/(\.\d*?)0+$/, "$1");
    strNum = strNum.replace(/\.$/, "");

    return Decimalization(strNum);
}

const Decimalization = (n) => {
    let str = String(n).toUpperCase()
    let arr = str.split('E-')
    let result;
    if (arr[1]) {
        result = (Number(arr[0]) / Math.pow(10, Number(arr[1]))).toFixed(Number(arr[1]) + arr[0].length - 2)
    }
    else {
        result = arr[0]
    }

    return result
}

const changeNum = (n) => {
    let num = String(n)
    let arr = num.split('.')
    let result;

    if (arr[1]) {
        result = Number(arr[0]).toLocaleString() + "." + arr[1]
    }
    else {
        result = Number(arr[0]).toLocaleString()
    }

    return result;
}

function formatDateTime(dateString) {
    let year, month, day, hour, minute;
    
    // YYYY-MM-DD HH:MM:SS 형식 체크
    if (dateString.includes('-')) {
        [year, month, day] = dateString.split(' ')[0].split('-');
        if (dateString.split(' ')[1]) {
            [hour, minute] = dateString.split(' ')[1].split(':');
        }
        year = year.slice(2); // YYYY에서 YY로 변환
    }
    // YYYYMMDD HHMMSS 형식
    else {
        year = dateString.slice(2, 4);
        month = dateString.slice(4, 6); 
        day = dateString.slice(6, 8);
        hour = dateString.slice(9, 11);
        minute = dateString.slice(11, 13);
    }

    // 새로운 형식으로 변환
    let result = `${year}-${month}-${day}`;
    if (hour) {
        result += ` ${hour}:${minute}`;
    }

    return result;
}

export { removeZeros, Decimalization, changeNum, formatDateTime }